var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconClone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.88 18c.62 0 1.12-.71 1.12-1.6V6.85c0-.88-.5-1.59-1.13-1.59H8.13C7.5 5.25 7 5.96 7 6.85v9.56c0 .88.5 1.59 1.13 1.59h6.74ZM8.12 4.5c-1.03 0-1.87.88-1.87 2.34v6.91H5.12c-.62 0-1.12-.71-1.12-1.6V2.6C4 1.71 4.5 1 5.13 1h6.75C12.5 1 13 1.71 13 2.6v1.9H8.12Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClone);
export default ForwardRef;